"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getBlockSendersConfirmTitleAndSubtext_1 = require("./getBlockSendersConfirmTitleAndSubtext");
var blockSenderService_1 = require("../../services/blockSenderService");
var owa_confirm_dialog_1 = require("owa-confirm-dialog");
/**
 * Shows the confirm dialog before sending out the block service call
 * @param mailboxes to block
 * @param blockActionCallback to be called upon sending out the service call
 */
function blockLastSendersHelper(mailboxes, blockActionCallback) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, title, subtext, confirmResponse;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!mailboxes) {
                        // Do nothing in case of invalid mailboxes,
                        // i.e mailboxes is null when user tries to block self
                        return [2 /*return*/];
                    }
                    _a = getBlockSendersConfirmTitleAndSubtext_1.default(mailboxes), title = _a[0], subtext = _a[1];
                    return [4 /*yield*/, owa_confirm_dialog_1.confirm(title, subtext)];
                case 1:
                    confirmResponse = _b.sent();
                    if (confirmResponse !== 0 /* ok */) {
                        return [2 /*return*/];
                    }
                    try {
                        blockSenderService_1.default(mailboxes);
                    }
                    catch (error) {
                        // VSO 19006: Handle service error caused by block
                    }
                    blockActionCallback();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = blockLastSendersHelper;
//# sourceMappingURL=blockLastSendersHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/blockLastSendersHelper.js
// module id = 3836
// module chunks = 62